import { RootState } from '../../store'
import { createSelector } from '@reduxjs/toolkit'

const selectUsers = (state: RootState) => state.users.users

export const selectAllUsers = createSelector(selectUsers, (users) => users)
